import * as React from 'react';
import { Button, List } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { FormItem } from '../../../../../components/Form';
import PriceRow from './components/PriceRow';
import PriceDetail from './components/PriceDetail';

export interface IPricesByWeightProps {
  name: string;
  deliveryMethod: GQL.IDeliveryMethod;
  currencies?: GQL.ICurrency[];
  onChange: Function;
}

export interface IPricesByWeightState {
  weightRange?: any;
}

export default class PricesByWeight extends React.Component<IPricesByWeightProps, IPricesByWeightState> {

  public constructor(props: IPricesByWeightProps) {
    super(props);

    this.state = {
      weightRange: null,
    };

    this.onChange = this.onChange.bind(this);
    this.onSavePrices = this.onSavePrices.bind(this);
  }

  public render() {
    const { deliveryMethod, currencies } = this.props;

    if (!currencies) {
      return null;
    }

    const primaryCurrency = currencies.find((currency: GQL.ICurrency) => currency.primary === true);

    const priceWeightRanges: string[] = [];
    (deliveryMethod.prices || [])
      .sort((a: GQL.IDeliveryMethodPrice, b: GQL.IDeliveryMethodPrice) => (a.fromWeight || 0) < (b.fromWeight || 0) ? -1 : 0)
      .forEach((price: GQL.IDeliveryMethodPrice) => {
        const t = `${price.fromWeight}-${price.toWeight}`;
        if (priceWeightRanges.indexOf(t) === -1) {
          priceWeightRanges.push(t);
        }
      });

    return (
      <div>
        <FormItem label={'Prices by order weight (vat excl.)'}>
          <List
            size={'small'}
            bordered={true}
            dataSource={priceWeightRanges || []}
            renderItem={(weightRange: any, index: number) => {
              return (
                <List.Item
                  actions={[
                    <Button
                      key={1}
                      danger={true}
                      size={'small'}
                      icon={<DeleteOutlined />}
                      onClick={() => {
                        this.onDeletePrices(weightRange);
                      }}
                    />
                  ]}
                  key={index}
                  style={{ paddingRight: '8px' }}
                >
                  <PriceRow
                    weightRange={weightRange}
                    prices={deliveryMethod.prices || []}
                    currency={primaryCurrency}
                    onClick={() => this.setState({ weightRange }) }
                  />
                </List.Item>
              );
            }}
          />
          <Button 
            onClick={() => this.setState({ weightRange: undefined })} 
            style={{ float: 'right', marginTop: 10 }}
          >
            New price
          </Button>
        </FormItem>

        {this.state.weightRange !== null && (
          <PriceDetail
            weightRange={this.state.weightRange}
            prices={this.getPricesByWeightRange(this.state.weightRange)}
            currencies={currencies}
            onSave={this.onSavePrices}
            onCancel={() => this.setState({ weightRange: null })}
          />
        )}
      </div>
    );
  }

  private getPricesByWeightRange(weightRange: string) {
    const { deliveryMethod } = this.props;
    
    return (deliveryMethod.prices || []).filter((price: GQL.IDeliveryMethodPrice) => { 
      return `${price.fromWeight}-${price.toWeight}` === weightRange;
    });
  }

  private onSavePrices(weightRange: string, prices: GQL.IDeliveryMethodPrice[]) {
    const { deliveryMethod } = this.props;
    
    let newPrices = (deliveryMethod.prices || []);

    if (weightRange !== undefined) {
      newPrices = newPrices.filter((price: GQL.IDeliveryMethodPrice) => {
        return `${price.fromWeight}-${price.toWeight}` !== weightRange;
      });
    }

    newPrices = newPrices.concat(prices);

    // uložení
    this.props.onChange({
      target: {
        name: this.props.name,
        value: newPrices,
      }
    });

    this.setState({
      weightRange: null,
    });
  }

  private onDeletePrices(weightRange: string) {
    const { deliveryMethod } = this.props;
    
    let newPrices = (deliveryMethod.prices || []);

    if (weightRange !== undefined) {
      newPrices = newPrices.filter((price: GQL.IDeliveryMethodPrice) => {
        return `${price.fromWeight}-${price.toWeight}` !== weightRange;
      });
    }

    this.props.onChange({
      target: {
        name: this.props.name,
        value: newPrices,
      }
    });
  }

  private onChange(key: string, val: any) {
    this.props.onChange({
      target: {
        name: key,
        value: val
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/PricesByWeight/PricesByWeight.tsx